import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { getPushState, subscribePush } from "@/lib/push";

export function EnableNotifications({ className = "" }) {
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => { getPushState().then(setState).catch(() => setState("unsupported")); }, []);

  if (state === "unsupported" || state === "loading") return null;

  const enable = async () => {
    setBusy(true);
    try {
      await subscribePush();
      setState("subscribed");
      toast.success("Notifications OMY activées 🔔");
    } catch (e) {
      if (e.message === "refusée") toast.error("Autorisation refusée dans le navigateur");
      else toast.error("Activation impossible pour l'instant");
    } finally { setBusy(false); }
  };

  if (state === "subscribed")
    return (
      <span data-testid="push-enabled" className={`inline-flex items-center gap-2 text-sm text-emerald-400 ${className}`}>
        <BellRing size={16} /> Notifications activées
      </span>
    );

  if (state === "denied")
    return (
      <span data-testid="push-denied" className={`inline-flex items-center gap-2 text-xs text-muted-foreground ${className}`}>
        <BellOff size={14} /> Notifications bloquées (réglages navigateur)
      </span>
    );

  return (
    <button data-testid="enable-push-btn" onClick={enable} disabled={busy}
      className={`inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full bg-primary hover:bg-primary/90 text-white text-sm font-medium transition-colors disabled:opacity-60 ${className}`}>
      <Bell size={16} /> {busy ? "…" : "Activer les notifications"}
    </button>
  );
}
